module.exports = __webpack_public_path__ + "img/1950.20c7775a.png";